import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useTwoMarkOpenBankingEvidenceSubmitted = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ legalEntityId }: { legalEntityId: number }) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `two/merchant-customer/mark-open-banking-evidence-submitted`,
        data: { legalEntityId },
      }).then(
        (response) =>
          apiV2AssertResponse<{ accountDetailsLastSubmittedAt: string }>(
            response,
          ).data,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.LegalEntity],
      });
    },
  });
};
